// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organization-users-dashboard[data-v-63b9c85f] .dashboard-data-table>.v-data-table__wrapper>table>tbody>tr.inactive>td{background-color:var(--v-gray-extra-light)}", ""]);
// Exports
module.exports = exports;
